export * from './filter-by-id.pipe';
export * from './reverse.pipe';
export * from './show-complete.pipe';
export * from './sort.pipe';



// WEBPACK FOOTER //
// ./src/app/global/_pipes/index.ts